module.exports = __webpack_public_path__ + "assets/da1f439294a7005b361b0542bd609e32.png";